import { Component, inject, Input } from '@angular/core';
import { DataLayer } from '../../../models/data-layer';
import { YearButtonComponent } from '../../atoms/year-button/year-button.component';
import { YearSelectButtonComponent } from '../../atoms/year-select-button/year-select-button.component';
import { LayerDropdownComponent } from '../../atoms/layer-dropdown/layer-dropdown.component';
import { Button } from 'primeng/button';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';

@Component({
  selector: 'app-year-list',
  standalone: true,
  imports: [
    YearButtonComponent,
    YearSelectButtonComponent,
    LayerDropdownComponent,
    Button,
  ],
  templateUrl: './year-list.component.html',
  styleUrl: './year-list.component.scss',
})
export class YearListComponent {
  readonly dataStore = inject(IndicatorDataStore);
  @Input() dataLayers!: DataLayer[];
  @Input() selectionMode: 'global' | 'multiple' = 'global';
  @Input() asDropdown = false;
  @Input() visibleCount = 5;
  @Input() indicatorId?: string;

  /**
   * Calculates the number of hidden data layers by subtracting the count of visible layers
   * from the total number of data layers. If the result is negative, it returns 0.
   *
   * @return {number} The number of hidden data layers. Always non-negative.
   */
  get hiddenCount(): number {
    return Math.max(this.dataLayers.length - this.visibleCount, 0);
  }

  /**
   * Displays all data layers by setting the visible count to the total number of layers.
   *
   * @return {void} Does not return any value.
   */
  showAll(): void {
    this.visibleCount = this.dataLayers.length;
  }
}
